import * as S from "./styled";

function Buttons({ selected, handleUpdate, amounts }) {
	return (
		<S.Container>
			{amounts.map((amount) => {
				return (
					<button
						key={amount.id}
						type="button"
						onClick={() => handleUpdate("amount", amount.id)}
						className={amount.id === selected ? "selected" : ""}
					>
						{amount.name}
					</button>
				);
			})}
		</S.Container>
	);
}

export default Buttons;
